import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLogos, createLogo, deleteLogo } from '../../lib/logos';

export const fetchLogos = createAsyncThunk('logos/getLogos', async () => {
  const data = await getLogos();
  return data;
});

export const addLogo = createAsyncThunk(
  'logos/addLogo',
  async (body, { rejectWithValue }) => {
    try {
      const data = await createLogo(body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const removeLogo = createAsyncThunk(
  'logos/removeLogo',
  async (logoId) => {
    await deleteLogo(logoId);
    return logoId;
  }
);